"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalLateral = void 0;
var x_1 = __importDefault(require("@lift/assets/dist/assets/icons/x"));
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var set_body_props_mapper_1 = require("../../utils/mappers/set-body-props/set-body-props.mapper");
var tags_ga_1 = require("../../utils/tags-ga");
var modal_lateral_styles_1 = require("./modal-lateral.styles");
var ModalLateral = function (_a) {
    var id = _a.id, conteudo = _a.conteudo, cabecalho = _a.cabecalho, arialLabel = _a.arialLabel, modalAberta = _a.modalAberta, idElementoFoco = _a.idElementoFoco, onClose = _a.onClose, arialLabelBotaoFechar = _a.arialLabelBotaoFechar, tagsGaBotaoFechar = _a.tagsGaBotaoFechar, dataSection = _a.dataSection, larguraModal = _a.larguraModal;
    var _b = (0, react_1.useState)(false), exibirConteudo = _b[0], setExibirConteudo = _b[1];
    var _c = (0, react_1.useState)(false), fecharConteudo = _c[0], setTransicaoFecharConteudo = _c[1];
    var modalRootContainer = document.querySelector('#modal-root');
    var focarElementoHtml = function (idElemento) {
        var elemento = document.getElementById(idElemento);
        elemento === null || elemento === void 0 ? void 0 : elemento.focus();
    };
    (0, react_1.useEffect)(function () {
        (0, set_body_props_mapper_1.setBodyProps)({ overflow: 'hidden', ariaHidden: true, tabIndex: -1 });
        return function () { return (0, set_body_props_mapper_1.setBodyProps)({ overflow: 'auto', ariaHidden: false }); };
    }, []);
    (0, react_1.useEffect)(function () {
        if (!modalAberta)
            setTimeout(function () { return setExibirConteudo(false); }, 400);
        else {
            setExibirConteudo(true);
            focarElementoHtml(id);
        }
    }, [modalAberta, id]);
    var component = (react_1.default.createElement(react_1.default.Fragment, null, exibirConteudo && (react_1.default.createElement(react_focus_lock_1.default, null,
        react_1.default.createElement(modal_lateral_styles_1.ConteudoModalLateralStyled, { "aria-label": arialLabel, role: "navigation", transicaoExibirConteudo: exibirConteudo, transicaoFecharConteudo: fecharConteudo, "data-section": dataSection, "data-testid": id, id: id, larguraModal: larguraModal },
            react_1.default.createElement(modal_lateral_styles_1.CabecalhoModalLateralStyled, null,
                react_1.default.createElement("div", null, cabecalho),
                react_1.default.createElement(tags_ga_1.TagsGa, { action: tagsGaBotaoFechar === null || tagsGaBotaoFechar === void 0 ? void 0 : tagsGaBotaoFechar.action, category: tagsGaBotaoFechar === null || tagsGaBotaoFechar === void 0 ? void 0 : tagsGaBotaoFechar.category, label: tagsGaBotaoFechar === null || tagsGaBotaoFechar === void 0 ? void 0 : tagsGaBotaoFechar.label, eventType: tagsGaBotaoFechar === null || tagsGaBotaoFechar === void 0 ? void 0 : tagsGaBotaoFechar.eventType },
                    react_1.default.createElement(modal_lateral_styles_1.BotaoFecharStyled, { onClick: function () {
                            setTransicaoFecharConteudo(true);
                            setTimeout(function () {
                                onClose();
                                focarElementoHtml(idElementoFoco);
                            }, 400);
                        }, "aria-label": arialLabelBotaoFechar ? arialLabelBotaoFechar : 'Fechar', "data-testid": "botao-fechar-modal-lateral" },
                        react_1.default.createElement(LftIconBase_1.default, { icon: x_1.default, size: "md" })))),
            react_1.default.createElement(modal_lateral_styles_1.AreaScrollStyled, null, conteudo))))));
    if (modalRootContainer) {
        return (0, react_dom_1.createPortal)(component, modalRootContainer);
    }
    return component;
};
exports.ModalLateral = ModalLateral;
